module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-sketch-6-dfe87874bf5b4ef351949a13f19909b2.svg";